import { Component, Input, ViewEncapsulation, inject } from "@angular/core";
import { CerrixInputValidationRequiredDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-required.directive";

@Component({
    selector: "cerrix-label",
    imports: [],
    templateUrl: "./cerrix-label.component.html",
    styleUrl: "./cerrix-label.component.scss",
    encapsulation: ViewEncapsulation.None,
    host: {
        "(click)": "$event.stopPropagation()",
    },
})
export class CerrixLabelComponent {
    @Input() for?: string;

    // The asterisk follows the appValidationRequired directive on the field this label names,
    // which a page puts on the whole field component — so the search has to cross out of the
    // template this label lives in, and cannot be narrowed with `host: true`. In practice a
    // marked field component holds exactly one label, which is the one this names.
    private requiredMarker = inject(CerrixInputValidationRequiredDirective, { optional: true });

    protected get isRequired(): boolean {
        return this.requiredMarker?.appValidationRequired ?? false;
    }
}
